import { useDispatch, useSelector } from "react-redux";
import { useGantt } from "../../hooks/useGantt";
import {
  Container,
  Header,
  ProjectTitle,
  StatusInfo,
  Label,
  TaskCounter,
  ProgressBar,
  ProgressTask,
  Box,
  MinusButton,
  PlusButton,
} from "./styles";
import { Timeline } from "./Timeline";
import { DateTime } from "luxon";
import { memo } from "react";
import { addZoom, subZoom } from "../../state/zaivuPersist/slice";

const MemoizedComponent = memo((props) => {
  return <Timeline  {...props} />;
});


const ZoomButton = ({ zoom }) => {
  const dispatch = useDispatch();

  return <Box>
    <span>Zoom</span>
    <div >
      <MinusButton onClick={() => dispatch(subZoom())} />
      <h2>{zoom}</h2>
      <PlusButton onClick={() => dispatch(addZoom())} />

    </div>
  </Box>

}

export function GanttTimeLine() {
  const flow = useSelector((state) => state.activedFlows.pane.flow);
  const ganttPersist = useSelector((state) => state.zaivuPersist.gantt)

  const { jobs } = useGantt();
  console.log("jobs :", jobs)
  const { zoom } = ganttPersist;
  const { title, createdAt } = flow;

  const year = DateTime.fromISO(createdAt).year;



  const doneTasks =
    jobs.length > 0
      ? jobs.reduce(
        (acc, item) =>
          item.status === "done" || item.status === "doneLate" ? ++acc : acc,
        0
      )
      : 0;

  const Progress = (doneTasks / jobs.length) * 100;

  const ResizableProps = {
    styles: {
      minWidth: "650px",
      maxWidth: "99vw",
    },
    minWidth: "50%",
    maxWidth: "99vw",
    defaultSize: {
      width: "100%",
    },
    enable: {
      right: true,
      bottom: false,
      top: false,
      left: false,
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false,
    },
    handleClasses: {
      right: "right-anchor-resizable",
    },
  };

  return (
    <>
      {jobs.length > 0 ? (
        <Container {...ResizableProps}>
          <Header>
            <ProjectTitle>
              <strong>{title}</strong>
              <span>{year}</span>
            </ProjectTitle>
            <div>
              <StatusInfo>
                <Label status="doneStatus">Concluído</Label>
                <Label status="pendingStatus">Pendente</Label>
                <Label status="doneLateStatus">Concluído com atraso</Label>
                <Label status="doingStatus">Em Execução</Label>
                <Label status="lateStatus">Atrasado</Label>
              </StatusInfo>
            </div>

            <div style={{ display: 'flex' }}>
              <ZoomButton zoom={zoom} />
              <TaskCounter>
                <h4>Tarefas</h4>
                <h2>
                  {doneTasks}/{jobs.length}
                </h2>
                <ProgressBar>
                  <ProgressTask value={Progress + "%"} />
                </ProgressBar>
              </TaskCounter>
            </div>
          </Header>
          <MemoizedComponent zoom={zoom} jobs={jobs} />
        </Container>
      ) : null}
    </>
  );
}
